export const STR = {
    nav: {
        id: {
            links: [
                { id: "layanan", href: "/#layanan", label: "Layanan" },
                { id: "paket", href: "/#paket", label: "Paket" },
                { id: "kalkulator", href: "/#kalkulator", label: "Kalkulator" },
                { id: "pembayaran", href: "/#pembayaran", label: "Pembayaran" },
                { id: "alur-kerja", href: "/#alur-kerja", label: "Alur Kerja" },
                { id: "blog", href: "/#blog", label: "Blog" },
                { id: "faq", href: "/#faq", label: "FAQ" },
            ],
            cta: "Hubungi via WhatsApp",
        },
        en: {
            links: [
                { id: "layanan", href: "/#layanan", label: "Services" },
                { id: "paket", href: "/#paket", label: "Packages" },
                { id: "kalkulator", href: "/#kalkulator", label: "Calculator" },
                { id: "pembayaran", href: "/#pembayaran", label: "Payment" },
                { id: "alur-kerja", href: "/#alur-kerja", label: "Workflow" },
                { id: "blog", href: "/#blog", label: "Blog" },
                { id: "faq", href: "/#faq", label: "FAQ" },
            ],
            cta: "Chat on WhatsApp",
        },
    },
    hero: {
        id: {
            badge: "Jasa Pembuatan Website Booking",
            line1: "Punya Kost, Villa, atau Hotel?",
            line2: "Saatnya Punya Website",
            line3: "Booking Sendiri.",
            sub: "Tamu bisa melihat kamar, cek tanggal kosong, dan bayar online — sementara Anda memantau semuanya dari satu dashboard.",
            ctaDemo: "Minta Contoh Tampilan Gratis",
            ctaPricing: "Lihat Paket",
            phone: "Lebih suka menelepon?",
            badges: ["Nyaman di HP", "Pembayaran Online", "Dashboard Owner"],
        },
        en: {
            badge: "Booking Website Development Service",
            line1: "Own a Kost, Villa, or Hotel?",
            line2: "Time to Have Your Own",
            line3: "Booking Website.",
            sub: "Guests can browse rooms, check available dates, and pay online — while you monitor everything from one dashboard.",
            ctaDemo: "Get a Free Design Preview",
            ctaPricing: "See Packages",
            phone: "Prefer to call?",
            badges: ["Mobile Friendly", "Online Payment", "Owner Dashboard"],
        },
    },
    marquee: {
        id: ["Website Booking", "Kost", "Villa", "Hotel", "Pembayaran Online", "Dashboard Owner", "Kalender Kamar", "Dukungan WhatsApp"],
        en: ["Booking Website", "Kost", "Villa", "Hotel", "Online Payment", "Owner Dashboard", "Room Calendar", "WhatsApp Support"],
    },
    problems: {
        id: {
            eyebrow: "Masalah Owner",
            title: "Kendala yang Sering Dialami Pemilik Properti",
            subtitle: "Kalau salah satu dari ini terasa familiar, website booking sendiri bisa jadi jawabannya.",
            cards: [
                { title: "Pertanyaan Berulang di Chat", desc: "Tamu menanyakan hal yang sama setiap hari: harga, fasilitas, tanggal kosong. Waktu Anda habis menjawab chat satu per satu." },
                { title: "Pesanan Dicatat Manual", desc: "Catatan di buku atau riwayat chat rawan terlewat, dobel booking, dan sulit dicek ulang saat sibuk." },
                { title: "Terlalu Bergantung Platform Pihak Ketiga", desc: "Komisi yang terus memotong keuntungan dan aturan platform membatasi cara Anda melayani tamu sendiri." },
                { title: "Tampilan Online Kurang Meyakinkan", desc: "Tanpa website yang profesional, calon tamu ragu dan akhirnya memilih properti lain yang terlihat lebih terpercaya." },
            ],
        },
        en: {
            eyebrow: "The Owner's Problem",
            title: "Common Struggles of Property Owners",
            subtitle: "If any of these sound familiar, having your own booking website could be the answer.",
            cards: [
                { title: "Repeating Questions in Chat", desc: "Guests ask the same things every day: price, facilities, available dates. Your time is spent answering chats one by one." },
                { title: "Orders Written Down Manually", desc: "Notes in books or chat history are easily missed, double-booked, and hard to recheck when busy." },
                { title: "Too Dependent on Third-Party Platforms", desc: "Commissions keep cutting into your profit, and platform rules limit how you serve your own guests." },
                { title: "Unconvincing Online Presence", desc: "Without a professional website, potential guests hesitate and choose another property that looks more trustworthy." },
            ],
        },
    },
    solutions: {
        id: {
            eyebrow: "Solusi TechFlaze",
            title: "Satu Website, Dua Sisi yang Sama-Sama Dimudahkan",
            subtitle: "Tamu mendapat pengalaman memesan yang mudah, Anda mendapat kendali penuh atas properti.",
            customer: {
                title: "Tampilan Customer",
                desc: "Halaman yang dilihat calon tamu Anda — dibuat seindah dan semudah mungkin.",
                features: ["Foto properti dan kamar yang menarik", "Fasilitas dan harga ditampilkan jelas", "Peta lokasi properti", "Cek tanggal kosong sebelum memesan", "Pesan dan bayar online langsung", "Nyaman dibuka di HP"],
            },
            owner: {
                title: "Dashboard Owner",
                desc: "Panel khusus untuk Anda memantau seluruh aktivitas properti dari satu tempat.",
                features: ["Pantau semua pesanan masuk", "Lihat status pembayaran tamu", "Kalender ketersediaan kamar", "Laporan pesanan yang rapi"],
            },
            mock: { pickDate: "Pilih tanggal…", bookNow: "Pesan Sekarang", payOnline: "Bayar Online", responsive: "Responsif di HP", monitor: "Pantau Kapan Saja", report: "Laporan", stats: ["Pesanan", "Lunas", "Kamar"] },
        },
        en: {
            eyebrow: "The TechFlaze Solution",
            title: "One Website, Two Sides Made Easier",
            subtitle: "Guests get an effortless booking experience, you get full control of your property.",
            customer: {
                title: "Guest View",
                desc: "The page your potential guests see — crafted to be as beautiful and easy as possible.",
                features: ["Attractive property and room photos", "Facilities and prices shown clearly", "Property location map", "Check available dates before booking", "Book and pay online directly", "Comfortable on mobile"],
            },
            owner: {
                title: "Owner Dashboard",
                desc: "A dedicated panel to monitor all your property activity from one place.",
                features: ["Monitor all incoming bookings", "See guest payment status", "Room availability calendar", "Neat booking reports"],
            },
            mock: { pickDate: "Pick a date…", bookNow: "Book Now", payOnline: "Pay Online", responsive: "Mobile Responsive", monitor: "Monitor Anytime", report: "Reports", stats: ["Bookings", "Paid", "Rooms"] },
        },
    },
    pricing: {
        id: {
            eyebrow: "Paket Harga",
            title: "Pilih Paket Sesuai Kebutuhan Properti Anda",
            subtitle: "Harga transparan, sekali bayar per proyek. Tidak ada biaya tersembunyi.",
            popular: "Paling Populer",
            choose: "Pilih Paket",
            note: "* Harga belum termasuk biaya domain, hosting, dan biaya payment gateway. Biaya tersebut mengikuti penyedia masing-masing dan akan kami bantu urus.",
            plans: {
                basic: { desc: "Untuk satu properti yang ingin tampil profesional.", features: ["Website untuk 1 properti", "Galeri foto properti", "Daftar fasilitas dan harga", "Peta lokasi", "Form pemesanan + tombol WhatsApp", "Dashboard owner dasar", "Revisi 2 kali"] },
                profesional: { desc: "Untuk properti yang siap menerima pembayaran online.", features: ["Semua fitur Basic", "Kalender ketersediaan kamar", "Pembayaran online (payment gateway)", "Notifikasi pesanan", "Dashboard pesanan", "Kode promo", "Revisi 3 kali"] },
                luxury: { desc: "Untuk pengelola banyak properti dengan kebutuhan lengkap.", features: ["Semua fitur Profesional", "Banyak properti dalam satu website", "Harga musiman", "Akun tamu dan ulasan", "Laporan pendapatan dan hunian", "Sinkron kalender dengan platform lain (bila didukung)", "Dua bahasa", "SEO lengkap", "Revisi 5 kali"] },
            },
        },
        en: {
            eyebrow: "Pricing",
            title: "Choose a Package That Fits Your Property",
            subtitle: "Transparent pricing, one-time per project. No hidden fees.",
            popular: "Most Popular",
            choose: "Choose Package",
            note: "* Prices exclude domain, hosting, and payment gateway fees. Those follow each provider's rates and we'll help take care of them.",
            plans: {
                basic: { desc: "For a single property that wants to look professional.", features: ["Website for 1 property", "Property photo gallery", "Facilities and price list", "Location map", "Booking form + WhatsApp button", "Basic owner dashboard", "2 revision rounds"] },
                profesional: { desc: "For properties ready to accept online payments.", features: ["Everything in Basic", "Room availability calendar", "Online payment (payment gateway)", "Booking notifications", "Booking dashboard", "Promo codes", "3 revision rounds"] },
                luxury: { desc: "For managers of multiple properties with complete needs.", features: ["Everything in Professional", "Multiple properties in one website", "Seasonal pricing", "Guest accounts and reviews", "Revenue and occupancy reports", "Calendar sync with other platforms (when supported)", "Two languages", "Full SEO", "5 revision rounds"] },
            },
        },
    },
    calculator: {
        id: {
            eyebrow: "Kalkulator Paket",
            title: "Bingung Pilih Paket? Jawab 3 Pertanyaan Ini",
            subtitle: "Kurang dari satu menit untuk menemukan paket yang paling sesuai dengan kebutuhan properti Anda.",
            questions: [
                { id: "properti", question: "Berapa banyak properti yang ingin Anda kelola dalam satu website?", options: [{ value: "satu", label: "Satu properti" }, { value: "banyak", label: "Beberapa properti" }] },
                { id: "bayar", question: "Apakah Anda ingin tamu bisa membayar online langsung di website?", options: [{ value: "ya", label: "Ya, perlu" }, { value: "tidak", label: "Belum perlu" }] },
                { id: "lanjutan", question: "Apakah Anda butuh fitur lanjutan seperti harga musiman, akun tamu, ulasan, atau dua bahasa?", options: [{ value: "ya", label: "Ya, butuh" }, { value: "tidak", label: "Tidak butuh" }] },
            ],
            resultLabel: "Rekomendasi untuk Anda",
            packageWord: "Paket",
            consult: "Konsultasi Paket",
            reset: "Ulangi",
            results: {
                basic: { reasons: ["Pas untuk satu properti", "Galeri, fasilitas, harga, dan peta lokasi", "Form pemesanan dengan tombol WhatsApp"] },
                profesional: { reasons: ["Kalender ketersediaan kamar", "Pembayaran online lewat payment gateway", "Notifikasi pesanan dan kode promo"] },
                luxury: { reasons: ["Banyak properti dalam satu website", "Harga musiman, akun tamu, dan ulasan", "Dua bahasa dan SEO lengkap"] },
            },
        },
        en: {
            eyebrow: "Package Calculator",
            title: "Not Sure Which Package? Answer 3 Questions",
            subtitle: "Less than a minute to find the package that best fits your property's needs.",
            questions: [
                { id: "properti", question: "How many properties do you want to manage in one website?", options: [{ value: "satu", label: "One property" }, { value: "banyak", label: "Several properties" }] },
                { id: "bayar", question: "Do you want guests to be able to pay online directly on the website?", options: [{ value: "ya", label: "Yes, needed" }, { value: "tidak", label: "Not yet" }] },
                { id: "lanjutan", question: "Do you need advanced features like seasonal pricing, guest accounts, reviews, or two languages?", options: [{ value: "ya", label: "Yes, needed" }, { value: "tidak", label: "Not needed" }] },
            ],
            resultLabel: "Recommended for You",
            packageWord: "Package",
            consult: "Consult the",
            reset: "Start Over",
            results: {
                basic: { reasons: ["Right for a single property", "Gallery, facilities, prices, and location map", "Booking form with WhatsApp button"] },
                profesional: { reasons: ["Room availability calendar", "Online payment via payment gateway", "Booking notifications and promo codes"] },
                luxury: { reasons: ["Multiple properties in one website", "Seasonal pricing, guest accounts, and reviews", "Two languages and full SEO"] },
            },
        },
    },
    payment: {
        id: {
            eyebrow: "Skema Pembayaran",
            title: "Pembayaran Bertahap, Aman dan Jelas",
            subtitle: "Anda tidak perlu membayar penuh di awal. Proyek berjalan dengan tiga tahap pembayaran yang transparan.",
            steps: [
                { title: "Booking Fee Rp 500.000", desc: "Mengunci jadwal pengerjaan proyek Anda agar masuk antrean prioritas." },
                { title: "DP 50%", desc: "Sudah termasuk booking fee. Pengerjaan website dimulai setelah DP diterima." },
                { title: "Pelunasan 50%", desc: "Dibayarkan sebelum serah terima dan peluncuran website Anda." },
            ],
            table: { plan: "Paket", dp: "DP 50%", settle: "Pelunasan 50%" },
            notePre: "Booking fee Rp 500.000",
            noteStrong: "bukan biaya tambahan",
            notePost: "— jumlahnya sudah termasuk di dalam DP 50%, sehingga total yang Anda bayar tetap sesuai harga paket.",
        },
        en: {
            eyebrow: "Payment Scheme",
            title: "Staged, Safe, and Clear Payments",
            subtitle: "You don't have to pay in full up front. The project runs on three transparent payment stages.",
            steps: [
                { title: "Booking Fee Rp 500.000", desc: "Locks your project's production slot so it enters the priority queue." },
                { title: "50% Down Payment", desc: "Already includes the booking fee. Website development starts once the down payment is received." },
                { title: "Final 50%", desc: "Paid before handover and launch of your website." },
            ],
            table: { plan: "Package", dp: "Down Payment 50%", settle: "Final Payment 50%" },
            notePre: "The Rp 500,000 booking fee is",
            noteStrong: "not an extra charge",
            notePost: "— it is already part of the 50% down payment, so your total stays the same as the package price.",
        },
    },
    workflow: {
        id: {
            eyebrow: "Alur Kerja",
            title: "Dari Booking Fee sampai Website Online",
            subtitle: "Proses yang jelas di setiap langkah — Anda selalu tahu proyek sedang di tahap apa.",
            steps: [
                { title: "Booking Fee", desc: "Amankan jadwal pengerjaan dengan booking fee Rp 500.000 (bagian dari DP)." },
                { title: "Diskusi & Materi", desc: "Kita diskusikan kebutuhan Anda, lalu Anda mengirimkan foto, harga, dan informasi properti." },
                { title: "DP & Pengerjaan", desc: "Setelah DP 50% diterima, tim TechFlaze mulai membangun website Anda." },
                { title: "Contoh Tampilan & Revisi", desc: "Anda melihat hasil pengerjaan dan memberikan masukan sesuai jatah revisi paket." },
                { title: "Uji Coba", desc: "Website diuji bersama-sama agar semua fitur berjalan lancar sebelum diluncurkan." },
                { title: "Pelunasan & Peluncuran", desc: "Setelah pelunasan 50%, website resmi online dan siap menerima tamu." },
            ],
        },
        en: {
            eyebrow: "Workflow",
            title: "From Booking Fee to Website Launch",
            subtitle: "A clear process at every step — you always know which stage your project is in.",
            steps: [
                { title: "Booking Fee", desc: "Secure your production slot with a Rp 500,000 booking fee (part of the down payment)." },
                { title: "Discussion & Materials", desc: "We discuss your needs, then you send photos, prices, and property information." },
                { title: "Down Payment & Build", desc: "Once the 50% down payment is received, the TechFlaze team starts building your website." },
                { title: "Design Preview & Revisions", desc: "You review the result and give feedback within your package's revision quota." },
                { title: "Testing", desc: "The website is tested together so every feature runs smoothly before launch." },
                { title: "Final Payment & Launch", desc: "After the final 50% payment, your website officially goes live and is ready to receive guests." },
            ],
        },
    },
    showcase: {
        id: {
            eyebrow: "Contoh Tampilan",
            title: "Contoh Tampilan Website",
            subtitle: "Beberapa contoh website yang bisa menjadi gambaran untuk properti Anda. Klik untuk melihat versi lengkapnya.",
            filters: [{ id: "semua", label: "Semua" }, { id: "kost", label: "Kost" }, { id: "villa", label: "Villa" }, { id: "warkop", label: "Warkop" }],
            empty: "Contoh untuk kategori ini segera hadir.",
            emptySub: "Lihat kategori lain, atau minta contoh tampilan gratis lewat WhatsApp.",
            demo: "Lihat demo",
            descs: {
                wowkost: "Platform pencarian kost dengan pencarian kota dan tampilan yang hangat.",
                canggukost: "Website kost bulanan di Canggu, Bali dengan gaya editorial yang tenang.",
                ngopideponk: "Website warkop di Depok dengan menu, galeri, dan ulasan bertema gelap.",
                kostbatan3: "Website kost putri eksklusif dengan pemesanan langsung via WhatsApp.",
            },
        },
        en: {
            eyebrow: "Showcase",
            title: "Website Design Showcase",
            subtitle: "A few example websites to help picture yours. Click to see the full version.",
            filters: [{ id: "semua", label: "All" }, { id: "kost", label: "Kost" }, { id: "villa", label: "Villa" }, { id: "warkop", label: "Coffee Shop" }],
            empty: "Examples for this category are coming soon.",
            emptySub: "Check other categories, or request a free design preview via WhatsApp.",
            demo: "View demo",
            descs: {
                wowkost: "A kost discovery platform with city search and a warm look.",
                canggukost: "A monthly kost website in Canggu, Bali with a calm editorial style.",
                ngopideponk: "A coffee shop website in Depok with menu, gallery, and reviews in a dark theme.",
                kostbatan3: "An exclusive women's kost website with direct WhatsApp booking.",
            },
        },
    },
    blog: {
        id: {
            eyebrow: "Blog & Tips",
            title: "Tips Mengelola Kost, Villa, dan Hotel",
            subtitle: "Artikel praktis seputar pengelolaan properti dan pemesanan online.",
            readMore: "Baca artikel",
            minRead: "menit baca",
        },
        en: {
            eyebrow: "Blog & Tips",
            title: "Tips for Managing Kosts, Villas, and Hotels",
            subtitle: "Practical articles on property management and online booking.",
            readMore: "Read article",
            minRead: "min read",
        },
    },
    faq: {
        id: {
            eyebrow: "FAQ",
            title: "Pertanyaan yang Sering Diajukan",
            subtitle: "Tidak menemukan jawaban? Silakan tanya langsung lewat WhatsApp.",
        },
        en: {
            eyebrow: "FAQ",
            title: "Frequently Asked Questions",
            subtitle: "Can't find your answer? Ask us directly via WhatsApp.",
            items: [
                { q: "Are domain and hosting included in the package price?", a: "Not yet. The package price covers website development. Domain, hosting, and payment gateway fees are paid separately according to each provider. Don't worry — we'll help set everything up until it's done." },
                { q: "How long does development take?", a: "It depends on the chosen package and how complete your materials are (photos, prices, descriptions). A clear time estimate is given after the initial discussion, and you'll be updated at every stage of the build." },
                { q: "Can it sync with Traveloka, Airbnb, or Booking.com?", a: "Calendar sync is available in the Luxury package as long as the platform supports it (e.g., via iCal calendar). Availability follows each platform's policy, and we'll check it together before the project starts." },
                { q: "How do payments work?", a: "Payments are staged: a Rp 500,000 booking fee to lock the schedule, a 50% down payment (already including the booking fee) before development, and the final 50% before handover. Account details and invoices are shared officially upon agreement." },
                { q: "Is there a monthly maintenance service?", a: "Yes, it's optional. Maintenance covers light content updates, security checks, and periodic backups. Pricing is flexible and can be discussed based on your property's needs." },
            ],
        },
    },
    cta: {
        id: {
            eyebrow: "Mulai Sekarang",
            titleA: "Siap Punya Website Booking",
            titleB: "Sendiri?",
            desc: "Isi form singkat ini, dan pesan Anda akan langsung terkirim ke WhatsApp kami. Konsultasi awal gratis, tanpa komitmen apa pun.",
            bullets: ["Respon langsung dari tim TechFlaze", "Bisa minta contoh tampilan terlebih dahulu", "Penjelasan paket dan biaya yang transparan", "Jam layanan WhatsApp: 09.00–17.00 WIB"],
            name: "Nama Anda",
            namePh: "cth. Budi Santoso",
            prop: "Nama Properti",
            propPh: "cth. Villa Asri Bali",
            type: "Jenis Properti",
            typeOther: "Lainnya",
            pack: "Paket yang Diminati",
            packUnsure: "Belum yakin, ingin konsultasi",
            msg: "Pesan (opsional)",
            msgPh: "Ceritakan singkat kebutuhan Anda…",
            submit: "Kirim via WhatsApp",
            note: "Tombol ini membuka WhatsApp dengan pesan yang sudah terisi otomatis.",
            hours: "Jam layanan: 09.00–17.00 WIB. Pesan yang masuk di luar jam layanan akan kami balas secara bertahap.",
            mapCaption: "Berbasis online — melayani pemilik kost, villa, dan hotel di seluruh Indonesia.",
        },
        en: {
            eyebrow: "Start Now",
            titleA: "Ready to Have Your Own",
            titleB: "Booking Website?",
            desc: "Fill in this short form and your message goes straight to our WhatsApp. The initial consultation is free, with no commitment at all.",
            bullets: ["Direct response from the TechFlaze team", "You can request a design preview first", "Transparent package and pricing explanation", "WhatsApp service hours: 09.00–17.00 WIB"],
            name: "Your Name",
            namePh: "e.g. Budi Santoso",
            prop: "Property Name",
            propPh: "e.g. Villa Asri Bali",
            type: "Property Type",
            typeOther: "Other",
            pack: "Package of Interest",
            packUnsure: "Not sure yet, I'd like a consultation",
            msg: "Message (optional)",
            msgPh: "Briefly describe your needs…",
            submit: "Send via WhatsApp",
            note: "This button opens WhatsApp with your message pre-filled.",
            hours: "Service hours: 09.00–17.00 WIB. Messages received outside service hours will be answered in stages.",
            mapCaption: "Online-based — serving kost, villa, and hotel owners across Indonesia.",
        },
    },
    footer: {
        id: {
            tagline: "Jasa pembuatan website booking untuk pemilik kost, villa, dan hotel di Indonesia.",
            contact: "Kontak",
            nav: "Navigasi",
            hours: "Jam layanan: 09.00–17.00 WIB",
            rights: "© 2026 TechFlaze. Seluruh hak cipta dilindungi.",
            founded: "Diresmikan 15 Oktober 2026 oleh Firdzi.",
        },
        en: {
            tagline: "Booking website development service for kost, villa, and hotel owners in Indonesia.",
            contact: "Contact",
            nav: "Navigation",
            hours: "Service hours: 09.00–17.00 WIB",
            rights: "© 2026 TechFlaze. All rights reserved.",
            founded: "Established October 15, 2026 by Firdzi.",
        },
    },
    misc: {
        id: { call: "Telepon", igniting: "Menyalakan" },
        en: { call: "Call", igniting: "Igniting" },
    },
    article: {
        id: {
            back: "Kembali ke Blog",
            share: "Bagikan via WhatsApp",
            minRead: "menit baca",
            ctaTitle: "Ingin website booking untuk properti Anda?",
            ctaDesc: "Konsultasikan kebutuhan kost, villa, atau hotel Anda dengan tim TechFlaze — gratis dan tanpa komitmen.",
            ctaBtn: "Minta Contoh Tampilan Gratis",
        },
        en: {
            back: "Back to Blog",
            share: "Share via WhatsApp",
            minRead: "min read",
            ctaTitle: "Want a booking website for your property?",
            ctaDesc: "Discuss your kost, villa, or hotel needs with the TechFlaze team — free and commitment-free.",
            ctaBtn: "Get a Free Design Preview",
        },
    },
};
